export default __webpack_public_path__ + "static/media/TransportationTrains_03.de577895.png";